export default function Topbar() {
    return (
        <header className="mb-6 flex flex-col gap-4 rounded-[28px] border border-rose-100 bg-white px-5 py-4 shadow-soft md:flex-row md:items-center md:justify-between">
            <div>
                <p className="text-sm font-medium text-gray-900">Fashion inventory dashboard</p>
                <p className="mt-1 text-sm text-gray-500">
                    Track stock, orders, and supplier activity for your Bangkok dress business.
                </p>
            </div>

            <div className="flex items-center gap-3">
                <div className="hidden rounded-2xl border border-rose-100 bg-rose-50 px-4 py-2 text-sm font-medium text-gray-700 md:block">
                    Spring Collection
                </div>
                <div className="flex items-center gap-3 rounded-2xl border border-rose-100 bg-white px-3 py-2">
                    <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-brand-100 text-lg">
                        👩
                    </div>
                    <div>
                        <p className="text-sm font-semibold text-gray-900">Admin</p>
                        <p className="text-xs text-gray-500">Owner account</p>
                    </div>
                </div>
            </div>
        </header>
    );
}